import { format } from "date-fns";

export const formattedDate = (dateString) => {
  if (!dateString) return ""; // Handle empty or undefined input
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

export const formattedDateMonth = (dateString) => {
  if (!dateString) return "N/A";
  return format(new Date(dateString), "dd MMM yyyy");
};
